import React, { useMemo } from "react";
import ActionButton from "../../components/ui/ActionButton";
import QRCodePreview from "../../components/ui/QRCodePreview";
import CommonDataTable from "../../components/ui/table/CommonTable";

const MasterTable = ({
  columns,
  data,
  entityName,
  isFetching,
  noDataComponent,
  onDeleteClick,
  onEditClick,
  onPageChange,
  onRowsPerPageChange,
  page,
  qrDisplayValue,
  qrValue,
  rowActions,
  rowsPerPage,
  searchedRecords,
  showDeleteAction = true,
  showEditAction = true,
  totalRecords,
}) => {
  const tableColumns = useMemo(
    () => {
      const qrColumn = qrValue
        ? [
            {
              name: "QR Code",
              width: "112px",
              center: true,
              style: {
                paddingTop: "10px",
                paddingBottom: "10px",
              },
              cell: (row) => (
                <div className="flex w-full justify-center py-1">
                  <QRCodePreview
                    value={qrValue(row)}
                    displayValue={qrDisplayValue?.(row)}
                    label={qrDisplayValue?.(row) || entityName}
                    size={54}
                  />
                </div>
              ),
            },
          ]
        : [];
      const hasActions = showEditAction || showDeleteAction || rowActions;
      const actionColumn = hasActions
        ? [
            {
              name: "Actions",
              width: rowActions ? "180px" : "132px",
              allowOverflow: true,
              cell: (row) => (
                <div className="flex items-center gap-2">
                  {showEditAction && (
                    <ActionButton
                      action="edit"
                      iconOnly
                      aria-label={`Edit ${entityName}`}
                      onClick={() => onEditClick(row)}
                    />
                  )}
                  {showDeleteAction && (
                    <ActionButton
                      action="delete"
                      iconOnly
                      aria-label={`Delete ${entityName}`}
                      onClick={() => onDeleteClick(row)}
                    />
                  )}
                  {rowActions?.(row)}
                </div>
              ),
            },
          ]
        : [];

      return [
        ...actionColumn,
        ...columns,
        ...qrColumn,
      ];
    },
    [
      columns,
      entityName,
      onDeleteClick,
      onEditClick,
      qrDisplayValue,
      qrValue,
      rowActions,
      showDeleteAction,
      showEditAction,
    ]
  );

  return (
    <CommonDataTable
      columns={tableColumns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRecords}
      paginationPerPage={rowsPerPage}
      filteredRowsCount={searchedRecords}
      page={page}
      progressPending={isFetching}
      onChangePage={onPageChange}
      onChangeRowsPerPage={onRowsPerPageChange}
      noDataComponent={noDataComponent}
    />
  );
};

export default MasterTable;
